












import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { Button } from '@/components/core';

@Component({
  components: { Button },
})
export default class Volume extends Vue {
  @Prop({ default: () => ({}) }) private mods!: Hash;
  @Prop({ default: () => 1 }) private value!: number;

  private blockName: string = 'volume';
  private height: number = 100;
  private changeVolumeDynamicly: boolean = false;
  private mute: number = 0;
  private icon: 'volume_off'|'volume_mute'|'volume_down'|'volume_up' = 'volume_up';

  @Watch('value')
  private onValueChanged(val: number, oldVal: number) {
    if (val === 0) {
      this.icon = 'volume_off';
    } else if (val <= 0.3) {
      this.icon = 'volume_mute';
    } else if (0.3 < val && val <= 0.6) {
      this.icon = 'volume_down';
    } else {
      this.icon = 'volume_up';
    }
  }

  private click(event: any) {
    this.$emit('changed', Number((event.offsetY / this.height).toFixed(2)));
  }

  private change(event: any) {
    if (!this.changeVolumeDynamicly) return;
    this.$emit('changed', Number((event.offsetY / this.height).toFixed(2)));
  }

  private startChanges(event: any) {
    this.changeVolumeDynamicly = true;
  }

  private stopChanges(event: any) {
    this.changeVolumeDynamicly = false;
  }

  private toggleMute(event: any) {
    if (this.mute === 0) {
      this.mute = this.value;
      this.$emit('changed', 0);
    } else {
      this.$emit('changed', this.mute);
      this.mute = 0;
    }
  }
}
